import { render, staticRenderFns } from "./segmentos.vue?vue&type=template&id=13ded5f5&scoped=true&"
import script from "./segmentos.vue?vue&type=script&lang=js&"
export * from "./segmentos.vue?vue&type=script&lang=js&"
import style0 from "./segmentos.vue?vue&type=style&index=0&id=13ded5f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ded5f5",
  null
  
)

export default component.exports